import apiService from './ApiService';

export default class SettingsApiService {

    /**
     * Gets a setting
     * @param {string} settingName
     * @returns {Promise<SettingDTO>}
     */
    async getSetting(settingName) {
        const setting = await apiService.getData('api/Setting/' + settingName);
        return setting.data.data;
    }

    /**
     * Whether the owner has switched text messaging on.
     *
     * Fails closed: if the setting cannot be read the feature is treated as off, so a failed request
     * hides the texting UI rather than offering tenants a feature that will not send anything. Accepts
     * the same values the server does, since the settings table stores free text.
     * @returns {Promise<boolean>}
     */
    async isSmsEnabled() {
        try {
            const setting = await this.getSetting('SmsEnabled');
            const value = setting?.value?.trim().toLowerCase();

            return value === 'true' || value === '1';
        } catch {
            return false;
        }
    }

    /**
     * Updates a setting
     * @param {SettingDTO} settingDto
     * @returns {Promise<SettingDTO>}
     */
    async updateSetting(settingDto) {
        const setting = await apiService.putData('api/Setting', settingDto);
        return setting.data.data;
    }

    /**
     * Gets the name for the website
     * @return {Promise<SettingDTO>}
     */
    async getSiteName() {
        const siteName = await apiService.getData('api/Setting/name/brand');
        return siteName.data.data;
    }

    /**
     * Gets the main site for the company
     * @return {Promise<SettingDTO>}
     */
    async getCompanyWebsite() {
        const siteAddress = await apiService.getData('api/Setting/name/site');
        return siteAddress.data.data;
    }
}
